import ReactMarkdown from 'react-markdown';

import { cn } from '@/lib/utils';

interface MarkdownProseProps {
	children: string;
	className?: string;
}

export function MarkdownProse({ children, className }: MarkdownProseProps) {
	return (
		<div
			className={cn(
				'flex flex-col gap-3.5 text-[15px] leading-[1.65] text-loomlite-muted',
				className,
			)}
		>
			<ReactMarkdown
				components={{
					h1: ({ children }) => (
						<h2 className="mt-2 font-heading text-xl font-semibold tracking-tight text-loomlite-text">
							{children}
						</h2>
					),
					h2: ({ children }) => (
						<h3 className="mt-2 font-heading text-lg font-semibold tracking-tight text-loomlite-text">
							{children}
						</h3>
					),
					h3: ({ children }) => (
						<h4 className="mt-1 font-heading text-base font-semibold text-loomlite-text">
							{children}
						</h4>
					),
					p: ({ children }) => <p className="m-0 text-loomlite-muted">{children}</p>,
					ul: ({ children }) => (
						<ul className="m-0 flex list-disc flex-col gap-1.5 pl-5 text-loomlite-muted">
							{children}
						</ul>
					),
					ol: ({ children }) => (
						<ol className="m-0 flex list-decimal flex-col gap-1.5 pl-5 text-loomlite-muted">
							{children}
						</ol>
					),
					li: ({ children }) => <li className="pl-1">{children}</li>,
					strong: ({ children }) => (
						<strong className="font-semibold text-loomlite-text">{children}</strong>
					),
					em: ({ children }) => <em className="italic text-loomlite-text">{children}</em>,
					a: ({ children, href }) => (
						<a
							href={href}
							className="text-loomlite-purple-soft underline-offset-2 hover:underline"
							target="_blank"
							rel="noreferrer noopener"
						>
							{children}
						</a>
					),
					blockquote: ({ children }) => (
						<blockquote className="border-l-2 border-loomlite-purple/50 pl-4 italic text-loomlite-muted">
							{children}
						</blockquote>
					),
					code: ({ children }) => (
						<code className="rounded bg-loomlite-card-alt px-1.5 py-0.5 font-mono text-[13px] text-loomlite-text">
							{children}
						</code>
					),
					hr: () => <hr className="my-2 border-loomlite-border" />,
				}}
			>
				{children}
			</ReactMarkdown>
		</div>
	);
}
